import { render, staticRenderFns } from "./listadoDocumentos.vue?vue&type=template&id=376211d7&scoped=true"
import script from "./listadoDocumentos.vue?vue&type=script&lang=js"
export * from "./listadoDocumentos.vue?vue&type=script&lang=js"
import style0 from "./listadoDocumentos.vue?vue&type=style&index=0&id=376211d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376211d7",
  null
  
)

export default component.exports